import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=548aeba6&scoped=true&"
var script = {}
import style0 from "./Advantage.vue?vue&type=style&index=0&id=548aeba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548aeba6",
  null
  
)

export default component.exports